module.exports = __webpack_public_path__ + "static/media/development-alamedas.ad4ddfd3.png";